import web_development from "../assets/web_developer.png";
import python from "../assets/python.png";
import ai_development from "../assets/ai_development.png";
import hacking from "../assets/hacking.png";

export const Education = () => {
  return (
    <section className="skills">
      <div className="sec_header">
        <h2 className="sec_head">My Education</h2>
      </div>
      <div className="skillset">
        <div className="skill">
          <img className="skill-icon" src={web_development} alt="Web Development Icon"/>
          <h3>Web Development</h3>
          <p>HTML, CSS, JavaScript, React</p>
        </div>
        <div className="skill">
          <img className="skill-icon" src={python} alt="Programming Languages Icon"/>
          <h3>Programming Languages</h3>
          <p>Python, C++, Java</p>
        </div>
        <div className="skill">
          <img className="skill-icon" src={ai_development} alt="Data Science Icon"/>
          <h3>Data Science</h3>
          <p>Machine Learning, Data Analysis</p>
        </div>
        <div className="skill">
          <img className="skill-icon" src={hacking} alt="Tools & Technologies Icon"/>
          <h3>Tools & Technologies</h3>
          <p>Git, Docker, AWS</p>
        </div>
      </div>
    </section>
  );
};